import React from 'react'
import moment from 'moment'
import Tippy from '@tippyjs/react'

export const isOutsideRange = (day, startDate, endDate, timezone, sameDayAvailable, closedDays, blackOutDates) => {



  let todayFormat = moment().tz(timezone).format('MM-DD-YYYY')
  let dayFormat = day.clone().format('MM-DD-YYYY')

  //if it's before today, because we can't do the past
  if (day.isBefore(todayFormat)) {
    return true
  }

  //if it's today, but same day is turned off
  if (todayFormat === dayFormat && sameDayAvailable === false) {
    return true
  }

  //if the day is blocked 
  if (checkBlockedDaysCalendar(day, blackOutDates)) {
    return true
  }

  if (startDate && endDate) {
    if (day.isBefore(startDate)) {
      return true
    }
    if (day.isAfter(endDate)) {
      //if is after 
      //find next blackout date after start date
      let nextBlackOutDate = null
      blackOutDates.forEach((bod, id) => {
        if (moment(bod, 'YYYY-MM-DD').isAfter(startDate)) {
          nextBlackOutDate = moment(bod, 'YYYY-MM-DD')
        }
      })
      if (day.isAfter(nextBlackOutDate)) {
        return true
      }
      //return true
    }
  }

  //if we entered a start date
  if (startDate) {
    //if it's before start date
    if (day.isBefore(startDate)) {
      return true
    }

    //find next blackout date after start date
    let nextBlackOutDate = null
    blackOutDates.forEach((bod, id) => {
      if (moment(bod, 'YYYY-MM-DD').isAfter(startDate)) {
        nextBlackOutDate = moment(bod, 'YYYY-MM-DD')
      }
    })
    if (day.isAfter(nextBlackOutDate)) {
      return true
    }
  }

  //if it's a closed day
  if (isDayClosed(day, closedDays)) {

    return true
  }

  return false

}


export const checkBlockedDaysCalendar = (day, blackOutDates) => {
  let inArray = false
  if (day) {
    let dayAsString = day.format('YYYY-MM-DD')
    var a = blackOutDates.indexOf(dayAsString)
    if (a !== -1) {
      inArray = true
    }
  }
  return inArray
}

export const isDayClosed = (day, closedDays) => {
  let inArray = false
  if (day) {
    let dayAsString = day.format('dddd')
    var a = closedDays.indexOf(dayAsString)
    if (a !== -1) {
      inArray = true
    }
  }
  return inArray
}

export const paymentModuleContents = (day, startDate, endDate, timezone, closedDays, blackOutDates, screenType, appendID) => {

  //screenType: desktop of mobile

  let showToolTip = false

  let today = moment().tz(timezone)

  if (isDayClosed(day, closedDays)) { //if day is closed show it
    showToolTip = true
  }

  if (day.isBefore(startDate)) { //if it's before start date
    showToolTip = false
  }

  if (day.isBefore(today) || day?.format('YYYY-MM-DD') === today?.format('YYYY-MM-DD')) { //if it's before today or today
    showToolTip = false
  }


  if (startDate) {
    let nextBlackOutDate = null
    blackOutDates.forEach((bod, id) => {
      if (moment(bod, 'YYYY-MM-DD').isAfter(startDate)) {
        nextBlackOutDate = moment(bod, 'YYYY-MM-DD')
      }
    })
    if (day.isAfter(nextBlackOutDate)) {
      showToolTip = false
    }
  }

  if (endDate) {
    if (day.isAfter(endDate)) {
      showToolTip = false
    }
  }



  if (showToolTip) {
    return (
      <Tippy
        //trigger="click"
        //sticky={true}
        arrow={true}
        arrowType={"sharp"}
        //hideOnClick={true}
        //theme="light-border"
        //interactive={true}
        content={startDate ? 'No Dropoff Available' : 'No Pickup Available'}
        //onShow={() => this.props.onOpen(info[0].bike_location.latitude, info[0].bike_location.longitude, info[0])}  
        appendTo={screenType === 'mobile' ? () => document.getElementById(appendID) : document.body}
      >
        <div className="calendar-day-inner">
          {day.format('D')}
        </div>
      </Tippy>
    )
  } //here we need a test for is closed days

  return (day.format('D'))
}

export const formatDatesForAPI = (startDate, endDate, timezone) => {

  if (!startDate || !endDate) {
    return
  }

  //set a default
  let startDateRC = moment.tz(startDate.format("YYYY-MM-DD 00:00"), timezone);

  //set a default
  let endDateRC = moment.tz(endDate.format("YYYY-MM-DD 00:00"), timezone);

  //if same day we need some offset so the server can see a time difference 1 hour is enough
  if (startDate.isSame(endDate)) {
    endDateRC = moment
      .tz(startDate.format("YYYY-MM-DD 00:00"), timezone)
      .add(1, "hours");
  }

  //if not the same day AND start date / end date spans a DST Change
  if (!startDate.isSame(endDate) && startDate.isDST() !== endDate.isDST()) {

    //If we are LEAVING DST
    if (startDate.isDST()) {
      //we don't do anything right now
    }

    //If we are GOING INTO DST
    if (!startDate.isDST()) {
      //we don't do anything right now
    }
  }

  let duration = moment.duration(endDateRC.diff(startDateRC));
  let days = Math.floor(duration.asDays());

  return {
    start: startDateRC.toISOString(),
    end: endDateRC.toISOString(),
    duration: days
  };
}